module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/application-settings/application-settings/application-settings.component.scss
// module id = ./src/app/components/framework/application-settings/application-settings/application-settings.component.scss
// module chunks = main